import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.3769 21.9886L8.24457 25.2937C7.71145 25.637 7.00691 25.4737 6.67179 24.9275C6.50723 24.6588 6.4558 24.3322 6.53037 24.024L7.36175 20.5829C7.63517 19.4519 8.3697 18.4957 9.37936 17.9583L14.1731 15.4085C14.432 15.2706 14.5331 14.944 14.3985 14.6788C14.294 14.4724 14.072 14.3583 13.8474 14.3943L8.50684 15.2601C7.23147 15.4673 5.93125 15.088 4.95245 14.2257L2.89712 12.4151C2.41972 11.9946 2.36486 11.2561 2.77542 10.767C2.97169 10.5335 3.25025 10.3886 3.54938 10.364L9.63307 9.86351C10.0633 9.8275 10.4379 9.54653 10.5999 9.13647L12.926 3.23151C13.1617 2.63267 13.826 2.34379 14.4105 2.58526C14.6977 2.7038 14.9257 2.93736 15.0414 3.23151L17.3684 9.13647C17.5304 9.54653 17.9041 9.8275 18.3343 9.86351L24.4506 10.3666C25.0789 10.4184 25.5468 10.9813 25.4963 11.6249C25.4723 11.9278 25.3343 12.2097 25.1106 12.4108L20.4025 16.6307C20.0854 16.9152 19.9474 17.3569 20.0434 17.7775L21.4825 24.0653C21.6265 24.694 21.2459 25.3218 20.6331 25.4693C20.3365 25.5404 20.0237 25.4868 19.7657 25.3209L14.5905 21.9886C14.2194 21.7498 13.748 21.7498 13.3769 21.9886Z",
      fill: "url(#premium_svg__paint0_linear_1175_9666)"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "premium_svg__paint0_linear_1175_9666",
        x1: "25.5",
        y1: "10.5",
        x2: "6.5",
        y2: "25.5",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#F978CB" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#2091FF"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }